const appColors = {
  mainColor: '#1a8fff',
  textColor: '#888',
  textColorLight: '#ccc',
  borderColor: '#eee',
  bgColor: '#e1e1e1',
  neutralColor: '#fff'
}

const styles = theme => ({
  header: {
    display: 'block',
    width: '100%',
    padding: '0.5em 0',
    borderBottom: `1px solid ${appColors.borderColor}`,
    background: appColors.neutralColor,
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '115%',
    color: appColors.textColor,
  },
  row: {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    borderBottom: `1px solid ${appColors.borderColor}`,
  },
  col: {
    flexGrow: 1,
    flexBasis: 0,
    maxWidth: '100%'
  },
  colCenter: {
    justifyContent: 'center',
    textAlign: 'center'
  },
  days: {
    fontWeight: '400',
    color: appColors.textColor,
    fontSize: '70%',
    padding: ' 0.75em 0',
    borderBottom: `1px solid ${appColors.borderColor}`
  },
  cell: {
    position: 'relative',
    height: '3em',
    borderRight: `1px solid ${appColors.borderColor}`,
    overflow: 'hidden',
    cursor: 'pointer',
    background: appColors.neutralColor,
    transition: '0.25s ease-out',
    '&:hover': {
      background: appColors.bgColor,
      transition: '0.2s ease-out'
    },
    '&:last-child': {
      borderRight: 'none'
    }
  },
  selected: {
    background: appColors.bgColor,
    transition: '0.2s ease-out'
  },
  disabled: {
    color: appColors.textColorLight,
    pointerEvents: 'none'
  },
  disbledTile: {
    color: appColors.textColorLight,
    pointerEvents: 'none'
  },
  number: {
    position: 'absolute',
    fontSize: '82.5%',
    lineHeight: 1,
    top: '50%',
    left: '50%',
    fontWeight: 700,
    transform: 'translate(-50%, -50%)'
  },
  indicator: {
    position: 'absolute',
    top: '75%',
    left: '46%',
    width: '5px',
    height: '5px',
    borderRadius: '10px'
  },
  popView: {
    display: 'none',
    position: 'fixed',
    background: '#ffffff',
    boxShadow: '1px 2px 8px #00000029',
    maxHeight: '150px',
    overflow: 'auto',
    width: '350px',
    zIndex: 1,
    padding: '20px',

    '&::before': {
      content: '\'\'',
      position: 'fixed',
      top: '-10px',
      left: '16%',
      borderStyle: 'solid',
      borderWidth: '0 10px 10px',
      borderColor: '#fff transparent',
      display: 'block',
      zIndex: 10
    },

    '&::-webkit-scrollbar': {
      width: '6px',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fafafa',
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3'
    }
  },
  popTitle: {
    font: 'normal normal bold 0.875rem Roboto',
    color: '#6f6f6f',
    margin: '4px 0'
  },
  popDetail: {
    font: 'normal normal normal 0.75rem Roboto',
    color: '#6f6f6f',
    margin: 0,
    fontSize: '14px'
  },
  popPower: {
    margin: 0,
    color: '#F37D27',
    font: 'normal normal bold 1.25em Roboto',
    marginBottom: '10px'
  },
  popUnit: {
    fontSize: '0.875rem'
  },
  optedOut: {
    fontSize: '0.875rem',
    color: '#F37D27',
    margin: 0,
    marginBottom: '10px'
  },
  calendar: {
    display: 'block',
    position: 'relative',
    width: '100%',
    background: appColors.neutralColor,
    border: `1px solid ${appColors.borderColor}`,
  },
  colPad: {
    padding: '12px'
  },
  sideArrowBar: {
    alignSelf: 'center'
  },
  arrowIcon: {
    fontFamily: 'Material Icons, serif',
    fontStyle: 'normal',
    fontSize: '40px',
    display: 'none',
    color: appColors.textColor,
    '-webkit-font-smoothing': 'antialiased',
    textRendering: 'optimizeLegibility',
    '-moz-osx-font-smoothing': 'grayscale',
    fontFeatureSettings: 'liga'
  },
  body: {
    fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 300,
    lineheight: 1.5,
    color: appColors.textColor,
    position: 'relative'
  },
  pointerEvent: {
    pointerEvents: 'none'
  },
  popDuration: {
    fontSize: '12px',
    marginTop: '4px',
    color: '#F37D27',
    fontWeight: 'bold'
  },
  halfWidth: {
    width: '48%',
    marginTop: '3%'
  },
  icon: {
    color: '#6F6F6F',
    width: '10%',
    textAlign: 'center',
    cursor: 'pointer'
  },
  disabledIcon: {
    pointerEvents: 'none',
    color: '#6F6F6F',
    opacity: '50%',
    width: '10%',
    textAlign: 'center'
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  calendarWrapper: {
    justifyContent: 'space-between',
    borderBottom: 'none'
  },
  fullWidth: {
    width: '100%'
  },
  rowWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  colWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px'
  },
  label: {
    color: '#6F6F6F',
    fontSize: '14px',
    opacity: '60%'
  },
  value: {
    color: '#6F6F6F',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  viewDetails: {
    textAlign: 'center',
    color: '#026AE3',
    marginBottom: '10px',
    cursor: 'pointer'
  }
})

export default styles
